var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#airplane_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.818 20.495l1.273-1.273-2.227-8.59 3.5-3.501a1.348 1.348 0 000-1.91 1.348 1.348 0 00-1.91 0l-3.5 3.501-8.59-2.227L4.09 7.767l7 3.819-3.5 3.5-3.5.318 2.546 2.546 2.546 2.545.318-3.5 3.5-3.5 3.818 7z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "airplane_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgAirplane;